<template>
  <!-- Page Content -->
  <div class="whole-page" style="height: 100%">
    <div class="navbar-div">
      <NavbarComponent :user="user" analysis="SUPERVISOR" />
    </div>
      que si
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";

export default {
  name: "Supervisor",
  components: {
    NavbarComponent
  },
  data() {
    return {
      user: []
    };
  },
  created() {
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
  }
};
</script>

<style scoped></style>
